import { SET_SHIPPING_OPTIONS } from "../reducers/configReducer";

export const updateShippingConfig = ({isPickup, isDelivery}) => {
  return {type: SET_SHIPPING_OPTIONS, payload: {isPickup, isDelivery}};
}


// WEBPACK FOOTER //
// ./src/actions/config_actions.js